import React, { useState } from "react";
import "./SkillsStyles.css";
import { BiCodeCurly } from "react-icons/bi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPaintBrush } from "react-icons/fa";
import LinearProgress from "@material-ui/core/LinearProgress";
import LightSpeed from "react-reveal/LightSpeed";
import Flash from "react-reveal/Flash";
import Fade from "react-reveal/Fade";

function Skills() {
  const [opened, setOpen] = useState(true);
  const [designSkillsOpened, setDesignSkillsOpened] = useState(true);
  const [backendSkillsOpened, setbackendSkillsOpened] = useState(true);
  const handleClick = () => {
    const prevValue = !opened;
    setOpen(prevValue);
  };

  return (
    <div id="skills" className="skills">
      <LightSpeed left>
        <h1 className="skills__heading">Skills</h1>
        <p className="skills__subheading">My Technical Level</p>
      </LightSpeed>
      <div className="skills__content">
        <div className="skills__frontend">
          <Fade top>
            <div className="skills__header">
              <div className="header__left">
                <BiCodeCurly fontSize="3rem" color="#845ec2" />
                <h3 className="skill__title">Frontend Development</h3>
              </div>
              <div className="header__right">
                <button className="skills__btn" onClick={handleClick}>
                  {opened ? (
                    <IoIosArrowDown fontSize="2rem" color="#333" />
                  ) : (
                    <IoIosArrowUp fontSize="2rem" color="#333" />
                  )}
                </button>
              </div>
            </div>
            {opened ? (
              <div className="skills__body">
                <div className="skill">
                  <h3 className="skill__textTitle">React</h3>
                  <p className="skill__percentage">80%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="80"
                  variant="determinate"
                />
                <div className="skill">
                  <h3 className="skill__textTitle">Javascript</h3>
                  <p className="skill__percentage">60%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="60"
                  variant="determinate"
                />
                <div className="skill">
                  <h3 className="skill__textTitle">HTML</h3>
                  <p className="skill__percentage">90%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="90"
                  variant="determinate"
                />
                <div className="skill">
                  <h3 className="skill__textTitle">CSS</h3>
                  <p className="skill__percentage">85%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="85"
                  variant="determinate"
                />
              </div>
            ) : (
              ""
            )}
          </Fade>
        </div>
        <div className="skills__design">
          <Fade top>
            <div className="skills__header">
              <div className="header__left">
                <FaPaintBrush fontSize="2.5rem" color="#845ec2" />
                <h3 className="skill__title">UI/UX Design</h3>
              </div>
              <div className="header__right">
                <button
                  className="skills__btn"
                  onClick={() => {
                    const prevValue = !designSkillsOpened;
                    setDesignSkillsOpened(prevValue);
                  }}
                >
                  {designSkillsOpened ? (
                    <IoIosArrowDown fontSize="2rem" color="#333" />
                  ) : (
                    <IoIosArrowUp fontSize="2rem" color="#333" />
                  )}
                </button>
              </div>
            </div>
            <div className={designSkillsOpened ? "skills__body" : "hide"}>
              <div className="skills__body">
                <div className="skill">
                  <h3 className="skill__textTitle">Figma</h3>
                  <p className="skill__percentage">60%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="60"
                  variant="determinate"
                />
                <div className="skill">
                  <h3 className="skill__textTitle">Adobe XD</h3>
                  <p className="skill__percentage">80%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="80"
                  variant="determinate"
                />
              </div>
            </div>
          </Fade>
        </div>
        <div className="skills__backend">
          <Fade top>
            <div className="skills__header">
              <div className="header__left">
                <FaPaintBrush fontSize="3rem" color="#845ec2" />
                <h3 className="skill__title">Backend Development</h3>
              </div>
              <div className="header__right">
                <button
                  className="skills__btn"
                  onClick={() => {
                    const prevValue = !backendSkillsOpened;
                    setbackendSkillsOpened(prevValue);
                  }}
                >
                  {backendSkillsOpened ? (
                    <IoIosArrowDown fontSize="2rem" color="#333" />
                  ) : (
                    <IoIosArrowUp fontSize="2rem" color="#333" />
                  )}
                </button>
              </div>
            </div>
            <div className={backendSkillsOpened ? "skills__body" : "hide"}>
              <div className="skills__body">
                <div className="skill">
                  <h3 className="skill__textTitle">Firebase</h3>
                  <p className="skill__percentage">60%</p>
                </div>
                <LinearProgress
                  color="secondary"
                  value="60"
                  variant="determinate"
                />
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default Skills;
